// extracted by mini-css-extract-plugin
export default {"main":"styles_main__2QvxN","content":"styles_content__AZYq8"};